// This entry point defines all the component that should be included in your extension.

export { HelloWorld } from './ui/HelloWorld';
